import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getLicensingFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    recommendedPumpingRate: numberField.optional(),
    annualVolume: numberField.optional(),
    licenseNo: z.string().nullable().optional(),
    licenseIssue: z.string().nullable().optional(),
    licenseExpiry: z.string().nullable().optional(),
    consumptionMonth: z.number().int().min(1).max(12).nullable().optional(),
    hoursPerDay: numberField.optional(),
    daysPerMonth: numberField.optional(),
    monthsPerYear: numberField.optional(),
  });
};

export type LicensingForm = z.infer<ReturnType<typeof getLicensingFormSchema>>;